"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConstants = void 0;
const state_1 = require("../state");
const getConstants = () => {
    if (state_1.state.values.constants === null) {
        throw new Error("Attempted to get constant before they were loaded.");
    }
    return state_1.state.values.constants;
};
exports.getConstants = getConstants;
